
import {
  Table,
  TableBody,
  TableCell,
  TableRow,
  Paper,
  Box,
  Grid,
} from "@mui/material";

import {


  TableContainer,
  TableHead,

  Typography,
} from "@mui/material";



import CurrencyCell from "../../../component/CurrencyCell";

export default function WGRGrandTotal({
  totals, summary
}) {


  // console.log("totals", totals);


  return (
    <Paper
      elevation={4}
      sx={{
        mt: 3,
        overflow: "hidden",
        border: "2px solid",
        borderColor: "success.main",
      }}
    >
      <TableContainer>
      <Table size="small">
        <TableBody>
          <TableRow
            sx={{
              bgcolor: "success.light",
              "& td": {
                fontWeight: 700,
                //fontSize: 15,
              },
            }}
          >


            <TableCell>
              GRAND TOTAL
            </TableCell>

            <TableCell align="right">
              <CurrencyCell
                value={totals.actual_L}
              />
            </TableCell>

            <TableCell align="right">
              <CurrencyCell
                value={totals.dist_L}
              />
            </TableCell>


            <TableCell align="right">
              <CurrencyCell
                value={totals.ou_LL}
              />
            </TableCell>




            <TableCell align="right">
              <CurrencyCell
                value={totals.actual_S}
              />
            </TableCell>

            <TableCell align="right">
              <CurrencyCell
                value={totals.dist_S}
              />
            </TableCell>


            <TableCell align="right">
              <CurrencyCell
                value={totals.ou_SS}
              />
            </TableCell>



          </TableRow>
        </TableBody>
      </Table>
      </TableContainer>
    </Paper>
  );
}

